import React from "react"
import { Trans } from "@lingui/macro"
import Content from "@components/Content"
import AreaHeader from "@components/AreaHeader/AreaHeader"
import NotificationList from "@components/NotificationList/NotificationList"
import { useQueryNotifications } from "@data/notifications/useQueryNotifications"

const Notifications = () => {
  const result = useQueryNotifications()

  return (
    <>
      <AreaHeader title={<Trans>Notifications</Trans>} titleIcon="notifications-dark" />

      <Content full start>
        <NotificationList popover={false} {...result} limit={null} spinnerSize={60} />
      </Content>
    </>
  )
}

export default Notifications
